import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';
import intl from 'react-intl-universal';
import { getServiceInitPage, resumeServiceInit, updateMenu, toggleSpinner } from '../state/serviceInitActions';
import { addToHistory } from 'src/utils/utilsActions';
import { push, goBack } from 'redux-first-history';
import { ServiceAddPres } from '../presentational/ServiceAddPres';
import ServiceDetailsPres from '../presentational/ServiceDetailsPres';
import { PageTitle } from 'src/ui/library/PageTitle';
import cloneDeep from 'lodash.clonedeep';
import { fetchServiceInitiationPolicies, saveServiceInitiationPolicies, saveNewServiceInitiation } from 'src/services/serviceinit.service';
import { DASHBOARD_URL, NEW_DASHBOARD_URL } from 'src/constants/constants.js';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import WarningIcon from '@material-ui/icons/Warning';
import { DEFAULT_DASHBOARD_VIEW, DEFAULT_SESSION_KEY } from '../../../../constants/constants';
import { fnIsDefaultOldView } from 'src/helpers/commonFunctions';

class ServiceInitAddContainer extends Component {
  state = {
    formValues: {},
    showServiceDetails: false,
    policyList: null,
    validationError: false,
    pageVal: {},
  };

  componentDidMount() {
    this.getPageData();
    this.props.addToHistory(window.location.pathname);
  }

  setFormValues = formValues => {
    this.setState({ formValues });
  };

  getPageData = () => {
    const { getServiceInitPage, resumeServiceInit, match } = this.props;

    if (get(match, 'params.serviceInitiationId') !== undefined) {
      return resumeServiceInit(match.params.serviceInitiationId);
    }

    getServiceInitPage({});
  };

  handleShowServiceDetails = pageVal => {
    const { entityId } = this.props.pageData;
    fetchServiceInitiationPolicies(entityId).then(response => {
      if (response.error) {
        throw Error(response.error.message);
      }

      this.setState({ showServiceDetails: true, policyList: response, pageVal });
    });
  };

  handleUpdatePolicy = (type, id) => {
    const policies = cloneDeep(this.state.policyList);
    const targetPolicy = policies[type].find(item => item.serviceId === id);

    if (targetPolicy) {
      targetPolicy.isSelected = !targetPolicy.isSelected;
      this.setState({ policyList: policies });
    }
  };

  handleSavePolicies = () => {
    this.props.toggleSpinner(true);
    this.setState({ showServiceDetails: false });

    const { policyList } = this.state;
    let updatedPolicies = [];

    Object.keys(policyList).forEach(serviceName => {
      const curPolicy = policyList[serviceName];
      if (Array.isArray(curPolicy)) {
        updatedPolicies.push(...curPolicy);
      }
    });

    const { entityId } = this.props.pageData;
    saveServiceInitiationPolicies(entityId, { services: updatedPolicies }).then(response => {
      this.props.toggleSpinner(false);

      if (response.error) {
        throw Error(response.error.message);
      }

      const { enqueueSnackbar, push } = this.props;
      enqueueSnackbar(intl.get('serviceInit.addInit.submitted'), { variant: 'success' });
      const orgOptions = {
        ...this.state.pageVal,
        isSubmitted: true,
      };
      saveNewServiceInitiation(orgOptions);
      if (fnIsDefaultOldView()) push(DASHBOARD_URL);
      else push(NEW_DASHBOARD_URL);
    });
  };

  onValidate = (fields, setErrorFn) => {
    const { ey_assignmentstartdate, ey_assignmentenddate, ey_employeeapplicantid } = fields;
    let validationError = false;
    if ((ey_assignmentstartdate && ey_assignmentenddate) || ey_employeeapplicantid === null) {
      if (moment(ey_assignmentenddate, 'DD-MMM-YYYY') < moment(ey_assignmentstartdate, 'DD-MMM-YYYY')) {
        const errorMsgOnStartDate = (
          <span className="error-msg">
            <WarningIcon />
            <b>Assignment Start Date cannot be after Assignment End Date.</b>
          </span>
        );
        const errorMsgOnEndDate = (
          <span className="error-msg">
            <WarningIcon />
            <b>Assignment End Date cannot be before Assignment Start Date.</b>
          </span>
        );

        setErrorFn('ey_assignmentstartdate', true, errorMsgOnStartDate);
        setErrorFn('ey_assignmentenddate', true, errorMsgOnEndDate);

        validationError = true;
      } else if (ey_employeeapplicantid === null) {
        validationError = true;
      } else {
        setErrorFn('ey_assignmentstartdate', false, null);
        setErrorFn('ey_assignmentenddate', false, null);
      }
    }
    this.setState({
      validationError,
    });
  };

  updateValidationErrorState = () => {
    this.setState({ validationError: false });
  };

  render() {
    let default_view = sessionStorage.getItem(DEFAULT_SESSION_KEY);
    let isDefaultOldView =
      default_view === null
        ? (process.env.SHOW_DEFAULT_OLD_VIEW_ENV || 'false').toLowerCase() === 'true'
        : default_view.toLowerCase() === DEFAULT_DASHBOARD_VIEW.EXISTING.toLowerCase();
    let title = intl.get('serviceInit.addInit.pageTitle');
    if (
      this.state.formValues &&
      this.state.formValues.formValues &&
      this.state.formValues.formValues.rawElements &&
      this.state.formValues.formValues.rawElements.length
    ) {
      let element = this.state.formValues.formValues.rawElements.find(function(el) {
        return el.controlTypeName === 'Header';
      });
      if (element && element.label) {
        title = intl.get('serviceInit.addInit.pageTitleCommon') + ' - ' + element.label;
      }
    }

    return (
      <React.Fragment>
        <PageTitle title={title} />
        {this.state.showServiceDetails && (
          <ServiceDetailsPres
            policyList={this.state.policyList}
            onSave={this.handleSavePolicies}
            onUpdatePolicy={this.handleUpdatePolicy}
          />
        )}
        <div className={isDefaultOldView ? '' : 'svc-landing-cnt'}>
          <ServiceAddPres
            formValues={this.state.formValues}
            setFormValues={this.setFormValues}
            setSaveHandler={this.setSaveHandler}
            onSave={this.handleSave}
            isServiceDetailsShown={this.showServiceDetails}
            showServiceDetails={this.handleShowServiceDetails}
            onValidate={this.onValidate}
            validationError={this.state.validationError}
            isEmployeeSelected={this.props.isEmployeeSelected}
            isDraft={this.props.isDraft}
            updateValidationErrorState={this.updateValidationErrorState}
            {...this.props}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  isLoading: state.serviceInit.isLoading,
  pageData: state.serviceInit.page,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
  isEmployeeSelected: ownProps.location.state
    ? ownProps.location.state.isEmployeeSelected
    : ownProps.pageData && ownProps.pageData.pageElements && ownProps.pageData.pageElements.find(x => x.displayText === 'Employee')
    ? true
    : false,
  isDraft: ownProps.location.state ? ownProps.location.state.isDraft : false,
});

const mapDispatchToProps = {
  getServiceInitPage,
  resumeServiceInit,
  push,
  goBack,
  addToHistory,
  updateMenu,
  toggleSpinner,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ServiceInitAddContainer));
